import ScriptloaderInstallWizardIframe from 'ui-addon-scriptloader/components/ScriptloaderInstallWizardIframe';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const ScriptloaderInstallModalPanel = ({
  onConfirm,
  onCloseComplete,
  onOpenStart,
  onOpenComplete,
  onReject,
  showStatus,
  installType
}) => {
  return /*#__PURE__*/_jsx(ModalPanel, {
    onCloseComplete: onCloseComplete,
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    children: /*#__PURE__*/_jsx(ScriptloaderInstallWizardIframe, {
      onConfirm: onConfirm,
      onReject: onReject,
      showStatus: showStatus,
      installType: installType
    })
  }, "uiScriptloader");
};
export default ScriptloaderInstallModalPanel;